import '@fontsource/archivo/600.css';
import '@fontsource/archivo/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from '@uroute/ui';
import { AuthProvider } from './lib/auth';
import { startQueue } from './lib/queue';
import { QueueUserBinder } from './lib/QueueUserBinder';
import { App } from './pages/AppRoutes';
import { registerSW } from 'virtual:pwa-register';
import { announceUpdateAvailable, setUpdateApplier } from './lib/install';

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh: () => announceUpdateAvailable(),
});

setUpdateApplier(async () => {
  await updateSW(true);
});

/* Start the offline queue as soon as the app boots ??? the driver's device
   may already hold queued work from a previous session. */
startQueue();

const container = document.getElementById('root');
if (!container) throw new Error('#root missing');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <QueueUserBinder />
          <App />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>,
);

// Hide boot splash once React has painted
const splash = document.getElementById('u-splash');
if (splash) {
  requestAnimationFrame(() => {
    splash.style.opacity = '0';
    setTimeout(() => splash.remove(), 300);
  });
}
